module.exports = __webpack_public_path__ + "img/list5.76c9237f.png";